<template>
    <div id="modelUpload" class="modelUpload">
        <el-dialog
            :title="diagTitle"
            :visible.sync="showFlag"
            :close-on-click-modal="false"
            :before-close="handleClose"
        >
            <div id="modelUploadContent">
                <!-- <el-button slot="trigger" size="small" type="primary" class="btnSelectFile">浏览
<input type="file" id="uploadFile" >
</el-button> -->
                <!-- 上传组件 -->
                <div class="upload-btn">
                    <el-upload
                        class="upload-demo"
                        drag
                        action="''"
                        :file-list="fileList"
                        :auto-upload="false"
                        :on-change="fileOnChange"
                        :show-file-list="false"
                        id="file-upload"
                        ref="upload"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text" id="bimbox-drag-file">
                            将文件拖到此处，或<em id="bimbox-click-file">点击上传</em>
                        </div>
                    </el-upload>
                </div>
                <!-- 提示 -->
                <div class="tips-content">
                    Tips: 试用版只能上传<span style="color: #ffaa3e;">500MB</span>文件，如需上传更大模型请至
                    <a class="tips-link" href="https://tm.pkpm.cn" target="_blank">图模大师</a>
                    体验
                </div>
                <!-- bucket选择框 -->
                <div class="bucket-select">
                    <span>选择对应的Bucket:<span style="color: red;">*</span></span>
                    <el-select v-model="bucketSelectVal">
                        <el-option
                            v-for="item in bucketOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>

                <!-- 上传列表组件 -->
                <UploadFileList ref="uploadFileList" :uploadFileList="uploadFileList"></UploadFileList>
                <div class="btn-group">
                    <el-button size="small" type="success" class="btnUploadFile" @click="submitUpload"
                        >确定上传
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import axios from 'axios';
import RuntimeUtils from 'src/common/js/runtimeUtils';
import { getUserName, getUserType } from 'src/utils/loginUtils';
import { getConverterTypes } from 'src/utils/jobUtils';
import { getSpaceCapacity } from 'src/utils/calculateUtils';

import $ from 'jquery';
import UploadFileList from './upload-file-list.vue';

export default {
    name: 'fileMngUpload',
    components: {
        UploadFileList,
    },
    props: {
        bucketOptions: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            showFlag: false, // 关闭模态框
            formLabelWidth: '80px',
            diagTitle: '',
            fileList: [],
            uploadFileList: [],
            bucketSelectVal: '', // 选中的bucket
            jobTypes: {},
            capacity: 0,
            usedCapacity: 0,
        };
    },
    mounted() {
        // 初始化文件类型
        const _self = this;
        getConverterTypes().then((res) => {
            _self.jobTypes = res.filetypes;
        });
        // 获取空间容量
        getSpaceCapacity().then((accountRes) => {
            if (accountRes) {
                _self.capacity = accountRes.data.capacity;
                _self.usedCapacity = accountRes.data.usedCapacity;
            }
        });
    },
    methods: {
        //  登录显示
        Open(bucketKey) {
            this.showFlag = true; //  打开模态框
            this.diagTitle = '文件上传';
            this.bucketSelectVal = bucketKey;
        },
        // 文件变化
        fileOnChange(file) {
            if (file.status === 'ready') {
                this.beforeFileListShow(file);
            }
        },
        beforeFileListShow(file) {
            let limitSize = 500 * 1024 * 1024;
            // 账户类型
            if (getUserType() === 'commercial') {
                limitSize = 4 * 1024 * 1024 * 1024;
            }
            // 空间大小
            if (this.capacity / 1024 / 1024 / 1024 > 1) {
                limitSize = 4 * 1024 * 1024 * 1024; // 限制4G
            }
            const filePostfixArr = file.name.split('.');
            const filePostfix = filePostfixArr[filePostfixArr.length - 1].toLowerCase();
            // 判断文件大小
            if (file.size > limitSize && getUserType() === 'trial') {
                this.removeFile(file);
                this.$message.error('试用版不得上传500MB以上的文件');
            } else if (!this.jobTypes[filePostfix]) {
                this.removeFile(file);
                this.$message.error('文件格式不支持');
            } else if (file.size > 40 * 1024 * 1024 * 1024) {
                this.removeFile(file);
                this.$message.error('文件大小超过限制，暂不支持上传');
            } else {
                // 自定义的file字段
                file.isChecked = true;
                file.percentage = 0;
                // this.BEFORE_FILE_LIST_SHOW(file)
                this.uploadFileList.push(file);
            }
        },
        removeFile(file) {
            const uploadIndex = this.$refs.upload.uploadFiles.findIndex((uploadFile) => uploadFile.uid === file.uid);
            if (uploadIndex !== -1) {
                this.$refs.upload.uploadFiles.splice(uploadIndex, 1);
            }
        },
        handleClose() {
            this.uploadFileList = []; // 文件清空
            this.$refs.upload.uploadFiles = [];
            this.bucketSelectVal = this.$store.state.storage.bucketKey;
            this.showFlag = false; //  关闭模态框
        },
        submitUpload() {
            const _self = this;
            if (_self.bucketSelectVal === '') {
                _self.$message('请选择对应的bucket');
                return;
            }
            // 判断空间是否超限
            let calculateSize = 0;
            this.uploadFileList.forEach((file, index) => {
                calculateSize += file.size;
            });
            if (calculateSize + this.usedCapacity >= this.capacity && this.capacity !== -1) {
                _self.$message('空间超过限制，请删除文件后上传');
                return;
            }
            // 获取文件上传路径
            this.uploadFileList.forEach((file, index) => {
                if (!file.isChecked) {
                    this.removeFile(file);
                }
            });
            // 储存对应的bucket
            _self.$store.commit('SET_BUCKETKEY', _self.bucketSelectVal);
            // 开启上传对话框
            _self.$store.commit('SET_FILELIST_STATUS', true);
            _self.$store.commit('SET_UPLOAD_FILELIST', [...this.$refs.upload.uploadFiles]);
            _self.handleClose();

            // 上传文件方式2
            // let promiseArr = []
            // uploadArray.forEach((ele, index) => {
            //   promiseArr.push(this.uploadFileControllor(uploadArray[index].name.replace('.', '_'), uploadArray[index].raw, index))
            // })
            // Promise.all(promiseArr).then(res => {
            //   _self.handleClose()
            //   // 列表刷新
            //   _self.$parent.refreshFileList()
            // })
        },
    },
};
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
.modelUpload >>> .el-upload__input
  display none

.modelUpload >>> .el-dialog
  width 450px

.modelUpload >>> .el-dialog__header
  width 450px
  height 40px
  line-height 40px
  font-family 'MicrosoftYaHei'
  padding 0
  padding-left 30px
  display flex
  align-items center

  .el-dialog__title
    color $font-black
    font-size 15px

  .el-dialog__headerbtn
    top 0px

    .el-dialog__close
      color $font-black

.modelUpload >>> .upload-demo
  justify-content center
  display flex

.modelUpload
  .tips-content
    padding 10px 20px 0px 20px
    line-height 18px

    .tips-link
      font-size 16px
      text-decoration none

  .bucket-select
    margin-left 6%
    margin-top 15px

  .bucket-select >>> .el-input__inner
    border-radius 5px
    width 236px

  .btn-group
    display flex
    justify-content flex-end
    margin-top 20px

    .btnUploadFile
      margin-right 20px
      width 100px
      height 40px
      margin-left 10px
      border-radius 20px
      border 0px
      background-color #0C78E2
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/fileMng-upload.vue